import { render, staticRenderFns } from "./TimeDefault.vue?vue&type=template&id=648fac64&scoped=true"
import script from "./TimeDefault.vue?vue&type=script&lang=js"
export * from "./TimeDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648fac64",
  null
  
)

export default component.exports